// extracted by mini-css-extract-plugin
export default {"tooltip":"Tooltip_tooltip__FkrWl","tooltiptext":"Tooltip_tooltiptext__Kj-nr"};